
export enum RelevanceType {
  Strength = 'strength',
  Development = 'development',
  NotImportant = 'not-important',
  Achieved = 'achieved',
}

export interface Relevance {
  type: RelevanceType,
  valueOfStrength :string,
  developmentGoals : string,
  remarksAndMilestones : string,
  actionPlans : {
    plan : string,
    area : string,
    from : [string, string],
    to : [string, string],
  }[]
}
